import React from "react";
import { ArrowLeft } from "lucide-react";
import ExportButton from "./ExportButton";

const ContactList = ({ groupName, groupSlug, onBack, onExportGroup }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm">
        <div className="flex flex-col gap-4 justify-between sm:flex-row sm:items-center">
          <div className="flex gap-4 items-center">
            <button
              onClick={onBack}
              className="p-2 text-gray-600 rounded-lg transition-colors duration-200 hover:text-gray-900 hover:bg-gray-100"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                {groupName} Contacts
              </h1>
              <p className="mt-1 text-gray-600">
                Export contacts from this group
              </p>
            </div>
          </div>

          <div className="flex gap-3 items-center">
            <ExportButton
              groupSlug={groupSlug}
              groupName={groupName}
              contactCount={0}
              variant="default"
              className="px-6 py-3"
            />
          </div>
        </div>
      </div>

      {/* Export Information */}
      <div className="p-6 bg-white rounded-2xl border border-gray-100 shadow-sm">
        <div className="py-12 text-center">
          <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gradient-to-br from-red-100 to-red-200 rounded-full">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>
          <h3 className="mb-2 text-lg font-semibold text-gray-900">
            Export {groupName} Contacts
          </h3>
          <p className="mb-6 text-gray-600">
            Request an Excel export of all contacts from this group. The file
            will be sent to your email for backup, analysis, or import into
            other systems.
          </p>
          <div className="grid grid-cols-1 gap-4 mx-auto max-w-2xl sm:grid-cols-3">
            <div className="flex flex-col gap-2 items-center p-4 bg-blue-50 rounded-xl border border-blue-200">
              <div className="flex justify-center items-center w-8 h-8 bg-blue-100 rounded-full">
                <svg
                  className="w-4 h-4 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <span className="text-sm font-medium text-blue-700">
                Excel Format
              </span>
              <span className="text-xs text-blue-600">.xlsx files</span>
            </div>
            <div className="flex flex-col gap-2 items-center p-4 bg-red-50 rounded-xl border border-red-200">
              <div className="flex justify-center items-center w-8 h-8 bg-red-100 rounded-full">
                <svg
                  className="w-4 h-4 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="text-sm font-medium text-red-700">
                Complete Data
              </span>
              <span className="text-xs text-red-600">All contact fields</span>
            </div>
            <div className="flex flex-col gap-2 items-center p-4 bg-purple-50 rounded-xl border border-purple-200">
              <div className="flex justify-center items-center w-8 h-8 bg-purple-100 rounded-full">
                <svg
                  className="w-4 h-4 text-purple-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <span className="text-sm font-medium text-purple-700">
                Email Delivery
              </span>
              <span className="text-xs text-purple-600">
                Sent to your inbox
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactList;
